import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CartViewB2c from "./CartViewB2C.vue";
import CheckoutCartWarning from "./CheckoutCartWarning.vue";
import { CheckoutModel } from "@/models/tapwell/Checkout";
import { OrderRow } from "@/models/tapwell/Cart";
import { CheckoutStore } from "@/store/bricmate-b2c/checkoutstate";
import { ApiService } from "@/services/bricmate/ApiService";

@Component({ components: { CartViewB2c, CheckoutCartWarning } })
export default class CheckoutB2C extends Vue {
    @Prop()
    protected viewmodel!: CheckoutModel;

    private viewmodelInternal!: CheckoutModel;
    private requestVersion: number = 0;
    protected error: string = "";
    protected translations: any = window.__litium.translation;

    get cart() { return CheckoutStore.cart; }
    get checkoutmodel(): CheckoutModel { return this.viewmodelInternal; }
    set checkoutmodel(value: CheckoutModel) { this.viewmodelInternal = value; }

    get catalogRows(): OrderRow[] {
        const catalogs = (this.viewmodel.catalogArticleNumbers || []).map((article) => article.toLowerCase());
        return (this.cart.orderRows || []).filter((row) => catalogs.indexOf(row.articleNumber.toLowerCase()) >= 0);
    }

    get cartSignature(): string {
        return JSON.stringify((this.cart.orderRows || []).map((row) => [row.articleNumber, row.quantity, row.totalPrice]));
    }

    constructor() {
        super();
        this.checkoutmodel = this.viewmodel;
    }

    async mounted() {
        try {
            await CheckoutStore.reloadState();
            await this.$nextTick();
            if (this.requestVersion === 0) {
                this.setPaymentProvider();
            }
        } catch {
            this.error = this.translations["checkout.catalogs.error"];
        }
    }

    @Watch("cartSignature")
    cartUpdated() {
        this.setPaymentProvider();
    }

    async setPaymentProvider() {
        const version = ++this.requestVersion;
        this.error = "";
        const container = document.getElementById("checkout-widget");
        if (container) {
            container.innerHTML = "";
        }
        if (this.catalogRows.length || !(this.cart.orderRows || []).length) {
            return;
        }
        try {
            const response = await ApiService.setPaymentProvider(this.checkoutmodel);
            if (version !== this.requestVersion || this.catalogRows.length) {
                return;
            }
            if (!response || !response.data || !response.data.paymentWidget || !response.data.paymentWidget.responseString) {
                throw new Error("Payment initialization failed");
            }
            this.checkoutmodel = response.data;
            await this.$nextTick();
            const checkoutContainer = document.getElementById("checkout-widget");
            if (!checkoutContainer || version !== this.requestVersion) {
                return;
            }
            checkoutContainer.innerHTML = this.checkoutmodel.paymentWidget.responseString;
            Array.from(checkoutContainer.getElementsByTagName("script")).forEach((script) => {
                const replacement = document.createElement("script");
                Array.from(script.attributes).forEach((attribute) => replacement.setAttribute(attribute.name, attribute.value));
                replacement.text = script.text;
                if (script.parentNode) {
                    script.parentNode.replaceChild(replacement, script);
                }
            });
            this.setShippingOption(version);
        } catch {
            if (version === this.requestVersion) {
                this.error = this.translations["checkout.catalogs.error"];
            }
        }
    }

    setShippingOption(version: number) {
        window._klarnaCheckout && window._klarnaCheckout((api) => {
            api.on({
                shipping_option_change: async (data) => {
                    if (version !== this.requestVersion || this.catalogRows.length) {
                        return;
                    }
                    try {
                        this.checkoutmodel.klarnaSelectedShippingOption = data;
                        const response = await ApiService.setShippingOption(this.checkoutmodel);
                        if (!response || !response.data) {
                            throw new Error("Shipping update failed");
                        }
                        await CheckoutStore.reloadState();
                    } catch {
                        this.error = this.translations["checkout.catalogs.error"];
                    }
                },
            });
        });
    }
}